import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  [<g key="0"><path fill="currentColor" d="M19 13H5v-2h14z" /></g>,<defs key="1"></defs>,]
, 'ActionRemovex');
